import React, { useState, useRef, HTMLAttributes } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Container, getContainerDynamicStyles } from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isVisible: boolean;
  duration?: number;
}

export const SlideToggle: React.FC<Props> = props => {
  const { isVisible, duration = 300, ...other } = props;
  const [slideHeight, setSlideHeight] = useState(isVisible ? undefined : 0);
  const childrenRef = useRef<HTMLDivElement>(null);

  const calcHeight = () => {
    const height = childrenRef.current?.offsetHeight;
    setSlideHeight(height);
  };

  const clearHeight = () => {
    setSlideHeight(undefined);
  };

  const nullifyHeight = () => {
    setSlideHeight(0);
  };

  return (
    <CSSTransition
      in={isVisible}
      timeout={duration}
      unmountOnExit={true}
      classNames="slide"
      onEnter={calcHeight}
      onEntered={clearHeight}
      onExit={calcHeight}
      onExiting={nullifyHeight}
    >
      <Container style={getContainerDynamicStyles({ slideHeight, duration })} {...other}>
        <div ref={childrenRef}>{props.children}</div>
      </Container>
    </CSSTransition>
  );
};
